<template>
  <div id="centros">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex xs12 >
          <h4 class="grey--text text--darken-1">
            <v-icon small color="primary">drag_indicator</v-icon> Gestión de Cursos Ofertados
          </h4>
        </v-flex>
      </v-layout>
      <v-card>
        <v-card-title class="headline lighten-3">
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Buscar"
            single-line
          >
          </v-text-field>
          <v-spacer></v-spacer>
          <v-btn color="primary" dark to="/curso/nuevo">Nuevo</v-btn>

          <v-flex xs12 class="my-0 py-0">
            <v-card-title class="grey lighten-4 py-1 px-1">
              <h6 class="grey--text text--darken-1">Solo puede eliminar cursos sin particpantes inscritos y que no esten cerrados.</h6>
            </v-card-title>
            <v-divider class="mb-0"></v-divider>
          </v-flex>
                
        </v-card-title>
        <v-data-table
            :headers="headers"
            :loading="loading"
            :items="curof"
            class="elevation-1"
            rows-per-page-text="Filas por página"
            no-data-text="No existen registros"
            no-results-text="Sin resultados"
            page-text="de"
            :rows-per-page-items="[10, 25, 50, 100, {'text': 'Todos', value: -1}]"
            v-bind:search="search"
            v-cloak
          >
            <template v-slot:items="props">
              <td>{{ props.index + 1 }}</td>
              <td>{{ props.item.nombre }}</td>
              <td>{{ props.item.gestion_tipo_id }}</td>
              <td>{{ props.item.fecha_inicio | formatdate }}</td>
              <td>{{ props.item.fecha_fin | formatdate }}</td>
              <td>{{ props.item.hora_inicio }}</td>
              <td>{{ props.item.hora_fin }}</td>
              <td><span v-if="props.item.es_vigente == true"><v-chip small color="success lighten-2">abierto</v-chip></span>
                <span v-else><v-chip small color="red lighten-2">cerrado</v-chip></span>
              </td>
              <td>
                <v-tooltip bottom>
                  <template v-slot:activator="{on}">
                    <v-btn
                      v-on="on"
                      dark
                      icon
                      small
                      depressed
                      color="primary"
                      @click="showDetail(props.item.codigomain)"
                    >
                      <v-icon small>visibility</v-icon>
                    </v-btn>
                  </template>
                  <span>Ver detalle</span>
                </v-tooltip>
                <div v-for="item in curcins">
                  <v-tooltip bottom >
                    <template v-slot:activator="{on}">
                      <v-btn
                        v-if="item.id == props.item.codigomain && item.es_vigente == true"
                        v-on="on"
                        dark
                        icon
                        small
                        depressed
                        color="red"
                        @click="confirmEliminado(props.item.codigomain)"
                      >
                        <v-icon small>delete</v-icon>
                      </v-btn>
                    </template>
                    <span>Eliminar curso ofertado</span>
                  </v-tooltip>
              </div>
              </td>
            </template>
          </v-data-table>
      </v-card>
    </v-container>
    <v-dialog
        v-model="dialogDetail"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
        scrollable
      >
        <detalle-curso :mcurso="curso" :mloading="loadingDetail" @close="dialogDetail = false"></detalle-curso>
    </v-dialog>

    <v-dialog v-model="mconfirm" width="300">
      <v-card>
        <v-card-title class="headline grey lighten-3" primary-title>
          <span class="headline">Alerta</span>
        </v-card-title>
        <v-card-text class="text-xs-center">Esta seguro(a) de eliminar el registro?</v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success darken-1" flat @click="deleteCursoOf()">
            Aceptar
          </v-btn>
          <v-btn color="blue darken-1" flat @click="mconfirm = false">
            Cancelar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
    <v-snackbar
      v-model="snack.state"
      top
      right
      :timeout="2500"
      :color="snack.color"
      :multi-line="snack.mode === 'multi-line'"
    >
      {{ snack.text }}
    </v-snackbar>
  </div>
</template>
<script>
/* eslint-disable no-console */
import Service from "../services/general";
import axios from "axios";
import DetalleCurso from '@/components/DetalleCurso';
export default {
  name: "cursosof",
  components: {
    DetalleCurso
  },
  data() {
    return {
      dialogDetail: false,
      loadingDetail: false,
      search: "",
      snack: {
          state: false,
          color: 'success',
          mode: '',
          text: ''
        },
      headers: [
        { text: 'Nro', align: 'left', sortable: false },
        { text: 'Curso ', value: 'nombre' },
        { text: 'Gestión ', value: 'gestion_tipo_id' },
        { text: "Fecha Inicio ", value: "fecha_inicio" },
        { text: 'Fecha Fin ', value: 'fecha_fin' },
        { text: 'Hora Inicio ', value: 'hora_inicio' },
        { text: 'Hora fin ', value: 'hora_fin' },
        { text: 'Estado ', value: 'es_vigente' },
        { text: 'Acción', sortable: false, width: '145px' }
       ],
      loading: false,
      curof: [],
      curso: [],
      codigo_centro: '',
      mconfirm: false,
      idborrar: '',
      curcins: ''
    };
  },
  mounted() {
    this.dparams = Service.getParams(); 
      if (this.dparams && this.dparams.roluser != Service.rol().director) {
        this.$router.push({name: 'principal'});
      }
      if (this.dparams != null) {
       
        this.getCursosOfertados();
        this.getCursosConInscritos();
        
      }
      
  },
  methods: {
   
    getCursosOfertados() { 

        this.dparams = Service.getParams();
        this.loading = true;
        axios
          .get(Service.getBase() + 'lista/cursosofertados/' + this.dparams.ie_id, Service.getHeader())
          .then(response => { 
            this.loading = false; 
            this.curof = response.data;
          })
          .catch(error => {
            this.loading = false;
            console.error("Error al cargar registros", error);
          });
    },
    getCursosConInscritos() { 
        this.loading = true;
        axios
          .get(Service.getBase() + 'lista/cursosinscritos', Service.getHeader())
          .then(response => { 
            this.loading = false; 
            this.curcins = response.data; 
          })
          .catch(error => {
            this.loading = false;
            console.error("Error al cargar registros", error);
          });
    },
    showDetail(codigo) { 
        this.dialogDetail = true;
        this.loadingDetail = true;
        Service.detalleCursoOf(codigo).then(response => {  
          this.curso = response.data.cursos; 
          this.loadingDetail = false;
          
        }).catch(error => {
          this.loadingDetail = false;
          console.error('Error al cargar datos', error);
        });
      },  
    confirmEliminado(curso_id) {
      this.idborrar = curso_id;
      this.mconfirm = true;
    },
    deleteCursoOf() {
      axios
        .delete(Service.getBase() + 'elimina/cursoof/' + this.idborrar, Service.getHeader())
        .then(() => {
          this.toast('success', 'Registro eliminado.');
          this.mconfirm = false;
          this.getCursosOfertados();
        })
        .catch(error => {
          console.error('Error al eliminar', error);
        });
    },
    toast(color, text) {
      this.snack.color = color;
      this.snack.text = text;
      this.snack.state = true;
    },
  }
};
</script>